import script from "./NovoUsuario.vue?vue&type=script&lang=ts&setup=true"
export * from "./NovoUsuario.vue?vue&type=script&lang=ts&setup=true"

import "./NovoUsuario.vue?vue&type=style&index=0&id=6e54940c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e54940c"]])

export default __exports__